import React from 'react';
import { Nav } from '@/components/Nav';
import { Hero } from '@/components/Hero';
import { ProblemSection } from '@/components/ProblemSection';
import { HowItWorks } from '@/components/HowItWorks';
import { CrossProviderDemo } from '@/components/CrossProviderDemo';
import { MemoryVisualization } from '@/components/MemoryVisualization';
import { SDKPreview } from '@/components/SDKPreview';
import { FeatureGrid } from '@/components/FeatureGrid';
import { Pricing } from '@/components/Pricing';
import { Integrations } from '@/components/Integrations';
import { TrustSection } from '@/components/TrustSection';
import { FAQ } from '@/components/FAQ';
import { CTASection } from '@/components/CTASection';
import { Footer } from '@/components/Footer';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-bg-primary">
      <Nav />
      <main>
        <section id="hero">
          <Hero />
        </section>
        <section id="problem">
          <ProblemSection />
        </section>
        <section id="how-it-works">
          <HowItWorks />
        </section>
        <section id="api">
          <CrossProviderDemo />
        </section>
        <MemoryVisualization />
        <section id="sdk">
          <SDKPreview />
        </section>
        <section id="features">
          <FeatureGrid />
        </section>
        <section id="pricing">
          <Pricing />
        </section>
        <section id="integrations">
          <Integrations />
        </section>
        <TrustSection />
        <section id="faq">
          <FAQ />
        </section>
        <CTASection />
        <Footer />
      </main>
    </div>
  );
};

export default HomePage;